import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ChevronRight } from 'lucide-react';

const SITE = 'https://buildconnect.be';

// items: [{ label, path }] — last item is the current page
export const Breadcrumbs = ({ items }) => {
  const all = [{ label: 'Accueil', path: '/' }, ...items];
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: all.map((it, i) => ({ '@type': 'ListItem', position: i + 1, name: it.label, item: `${SITE}${it.path}` })),
  };
  return (
    <nav aria-label="Fil d'Ariane" className="text-xs text-[#6B7280] flex flex-wrap items-center gap-1" data-testid="breadcrumbs">
      <Helmet><script type="application/ld+json">{JSON.stringify(jsonLd)}</script></Helmet>
      {all.map((it, i) => (
        <span key={it.path} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="w-3 h-3" />}
          {i < all.length - 1 ? <Link to={it.path} className="hover:text-[#1E3A8A] hover:underline">{it.label}</Link> : <span className="text-[#111827] font-medium">{it.label}</span>}
        </span>
      ))}
    </nav>
  );
};
